import React from 'react';
import classes from './DocumentTable.module.scss'
import { useAppDispatch, useAppSelector } from 'store/hook';
import { Button, Empty } from 'antd';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { defaultSidebarWidth, setIsTourOpen, setSelectedKeys, setSideBarWidth } from 'store/slices/windowStateSlice';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Assets from 'assets/icons';

type EmptyProps = {
  currentFooterHeight: number;
}

const EmptyTableElement = ({ currentFooterHeight }: EmptyProps) => {
  const { currentFolder, emptyText, dataDocumentTable } = useAppSelector(store => store.documents);
  const { sideBarWidth } = useAppSelector(store => store.windowState);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const navigateToFaq = (section: string) => {
    navigate(`/ref/?section=${section}`)
    dispatch(setSelectedKeys(['ref']));
  };
  
  const openTour = () => {
    if (sideBarWidth === 64) {
      localStorage.setItem('sideBarWidth', String(defaultSidebarWidth));
      dispatch(setSideBarWidth(defaultSidebarWidth));
    }
    setTimeout(() => {
      dispatch(setIsTourOpen(true));
    }, 40);
  }

  const isNeedToShowHints = emptyText === 'fallback' && !Boolean(currentFolder[0]) && !Boolean(dataDocumentTable[0]);

  return (
    <div className={classes.emptyWrap} style={{height: `calc(100dvh - ${(157 + currentFooterHeight)}px)`}}>

      { emptyText === 'blocked' 
        ? <div className={classes.blocked}>
          <Assets.LockIcon />
          <div>{t(`Documents.table.${emptyText}1`)}</div>
          <div>{t(`Documents.table.${emptyText}2`)}</div>
        </div>
        : (!Boolean(dataDocumentTable[0]) && <Empty
          className={classes.emptyImg}
          description={t(`Documents.table.${emptyText}`)}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />)
      }

      {isNeedToShowHints && (
        <Button
          style={{marginBottom: 20}}
          type='primary'
          onClick={openTour}
          icon={<QuestionCircleOutlined style={{fontSize:18}}/>}
        >
        {t(`Documents.table.showHint`)}
        </Button>
      )}

      {isNeedToShowHints && (
        <div
          className={classes.tipsItem}
          onClick={() => navigateToFaq('5.3')}
        >
          <div className={classes.tipsPrefix}>
            <Assets.FileAddIcon />
          </div>
          <div className={classes.tipsText}>
            {t(`Documents.table.howAddFiles`)}
          </div>
          <div className={classes.tipsPostfix}>
            <Assets.RightIcon />
          </div>
        </div>
      )}

      {isNeedToShowHints && (
        <div
          className={classes.tipsItem}
          onClick={() => navigateToFaq('4.7')}
        >
          <div className={classes.tipsPrefix}>
            <Assets.MemberAddIcon />
          </div>
          <div className={classes.tipsText}>
            {t(`Documents.table.howAddMembers`)}
          </div>
          <div className={classes.tipsPostfix}>
            <Assets.RightIcon />
          </div>
        </div>
      )}

      {isNeedToShowHints && (
        <div
          className={classes.tipsItem}
          onClick={() => navigateToFaq('3.3')}
        >
          <div className={classes.tipsPrefix}>
            <Assets.SettingsIcon />
          </div>
          <div className={classes.tipsText}>
            {t(`Documents.table.howSetupRoom`)}
          </div>
          <div className={classes.tipsPostfix}>
            <Assets.RightIcon />
          </div>
        </div>
      )}

    </div>
  );
}

export default EmptyTableElement;
